import { HealthDetailPage } from '@/components/shared/ReuseableHealthDeatil';
import { useGetMyMicrobiomeDetailV2 } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { MicrobiomeDetailResponse } from '@viome/viome-base/src/usecase/Health/Health.model';
import { JourneyEducationTypes } from '@utils/JourneyEducationTypes';
import { getDysbiosisAnimation } from '@utils/health/getAnimation';
import GutDysbiosis from '@/assets/dysbiosis_gut.json';

export const GutDybiosisPage = () => {
  const { data, isLoading, isError } = useGetMyMicrobiomeDetailV2('gut');

  if (isError) {
    return (
      <div className="dark bg-black h-full w-full flex justify-center items-center">
        <p className="typography-body text-primary">
          Failed to load data. Please try again.
        </p>
      </div>
    );
  }

  if (!data?.dysbiosis) {
    return null;
  }

  const { dysbiosis }: MicrobiomeDetailResponse = data;

  return (
    <HealthDetailPage
      data={{
        title: dysbiosis.title,
        about: dysbiosis.about,
        mainStat: String(dysbiosis.message),
        subStat: dysbiosis.rank,
        rankColor: dysbiosis.rank_color,
        size: 'lg',
        overlayImg: '',
        inflammagingTrend: dysbiosis.trend,
        fallBackVdo: GutDysbiosis,
        videoSrc: getDysbiosisAnimation('gut'),
        scoreId: dysbiosis.id,
      }}
      journeyDeeperSectionInfo={JourneyEducationTypes.GUT_MICROBIOME_DETAIL}
      isLoading={isLoading}
      screen="gut_dysbiosis"
    />
  );
};
